import React from "react";
import './index.less'
export default function Footer(props) {
	return (
		<div className="abouttitle">
			<h2>{props.english}</h2>
			<h3>{props.name}</h3>
		</div>
	);
}
